module.exports = __webpack_public_path__ + "img/delete-new.4eb942cd.svg";